<template>
  <article class="text-dark">
    <ValidationObserver ref="loginForm">
      <section v-if="!isShowingForgotPassword">
      <SubscriptionLoading v-if="isloading" :isLoading="isloading"></SubscriptionLoading>
      <header>
        <h4 class="text-danger col-xxs-12 d-xs-12 py-xxs-3 py-sm-4 pt-xxs-4">{{$t('login.title')}}</h4>
      </header>
      <section class="px-3">
        <b-form-group>
          <label for="cellOrEmail">
            {{$t(inputType.cellOrEmailLabel)}}
          </label>
          <b-form-input id="cellOrEmail"
                        name="cellOrEmail"
                        ref="cellOrEmail"
                        class="dir-ltr mb-md-0 mb-2"
                        :type="inputType.type"
                        v-model.trim="model.username"
                        :placeholder="$t(inputType.cellOrEmailPlaceholder)"
                        v-validate="{ required: true,regex: inputType.regex }"
                        :data-vv-as="$t(inputType.cellOrEmailLabel)"
                        :state="errors.has('cellOrEmail') ? false : null"
                        aria-describedby="cellOrEmail"></b-form-input>
          <b-form-invalid-feedback id="cellOrEmail">
            <ul class="list-unstyled px-0">
              <li :key="error" v-for="error in errors.collect('cellOrEmail')">{{ error}}</li>
            </ul>
          </b-form-invalid-feedback>


          <b-form-invalid-feedback id="login.cellOrEmail">
            <ul class="list-unstyled px-0">
              <li v-for="error in errors.collect('login.cellOrEmail')" v-bind:key="error">{{ error }}</li>
            </ul>
          </b-form-invalid-feedback>
          <b-link @click="toggleInputType()"
                  href="#"
                  class="d-xxs-inline d-md-none text-decoration-none">
            {{$t(inputType.loginType)}}
          </b-link>
        </b-form-group>
        <b-form-group>
          <label for="password">{{$t('login.password')}}</label>
          <b-input-group>
                        <template v-slot:append>
                          <b-button variant="light" class="pt-2 rounded-right show-password" :class="{'icon-eye':!isPasswordVisible,'icon-eye-slash':isPasswordVisible}" @click="togglePassword"/>
                        </template>
          <b-form-input id="password"
                        v-model.trim="model.password"
                        :type="passwordFieldType"
                        placeholder="********"
                        class="dir-ltr"
                        name="password"
                        :state="errors.has('password') ? false : null"
                        v-validate="'required'"
                        aria-describedby="password"
                        data-vv-as="register.password">
                        </b-form-input>
          <b-form-invalid-feedback id="password">{{ errors.first('password') }}</b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
        <section class="mt-sm-5 mt-4 d-flex flex-xxs-column flex-sm-row justify-content-between align-items-center">
          <b-form-checkbox id="rememberMe"
                           v-model="model.rememberMe"
                           class="col-xxs-12 col-sm-8 pr-0 mt-1">{{$t('login.rememberMe')}}</b-form-checkbox>
          <b-button block
                    variant="primary"
                    class="submit py-2 mt-sm-0 mt-3"
                    size="lg"
                    id="submit"
                    type="submit"
                    @click="login">{{$t('login.submitLogin')}}</b-button>
        </section>
      </section>
      <ErrorBox v-if="serverError" :errorMessage="serverError"></ErrorBox>
      <section>
        <b-link class="forgot-password d-flex mx-3 mt-sm-5 mt-3 text-decoration-none" @click="forgotPassword">
          <strong>{{$t('login.forgotPassword')}}</strong>
        </b-link>
      </section>
      </section>
    </ValidationObserver>
    <ValidationObserver ref="forgotPasswordForm">
      <section v-if="isShowingForgotPassword">
      <h3 class="text-danger col-xxs-8 d-xs-12 py-xxs-3 py-sm-5 pt-xxs-4">{{$t('login.resetPassword')}}</h3>
      <section v-if="isShowingUserNameInput">
        <b-form-group>
          <label for="cellOrEmail">{{$t(inputType.cellOrEmailLabel)}}</label>
          <b-form-input id="cellOrEmailResetPassword"
                        name="cellOrEmailResetPassword"
                        ref="cellOrEmailResetPassword"
                        class="dir-ltr"
                        :type="inputType.type"
                        v-model.trim="model.username"
                        :placeholder="$t(inputType.cellOrEmailPlaceholder)"
                        v-validate="{ required: true,regex: inputType.regex }"
                        :data-vv-as="$t(inputType.cellOrEmailLabel)"
                        :state="errors.has('cellOrEmailResetPassword') ? false : null"
                        aria-describedby="cellOrEmailResetPassword"></b-form-input>
          <b-form-invalid-feedback id="cellOrEmailResetPassword">
            <ul class="list-unstyled px-0">
              <li :key="error" v-for="error in errors.collect('cellOrEmailResetPassword')">{{ error}}</li>
            </ul>
          </b-form-invalid-feedback>
          <b-form-invalid-feedback id="login.cellOrEmailResetPassword">
            <ul class="list-unstyled px-0">
              <li v-for="error in errors.collect('login.cellOrEmailResetPassword')" v-bind:key="error">{{ error }}</li>
            </ul>
          </b-form-invalid-feedback>
          <b-link @click="toggleInputType()"
                  href="#"
                  class="d-xxs-inline d-md-none text-decoration-none">{{$t(inputType.loginType)}}</b-link>
        </b-form-group>
        <div class="d-flex mt-4 justify-content-between">
          <b-link class="text-dark d-flex lead align-items-center" @click="backToLoginPage">
            <img height="30" class="bidi-icon" src="@/assets/icons/back.svg">
            <span class="px-2">{{$t('common.back')}}</span>
          </b-link>
          <b-button block
                    variant="primary"
                    class="submit w-50"
                    size="lg"
                    id="submit"
                    type="submit"
                    @click="requestResetPasswordToken">{{$t('security.loginButtonText')}}</b-button>
        </div>
        <ErrorBox v-if="forgotPasswordError" :errorMessage="forgotPasswordError"></ErrorBox>
      </section>
      <section v-if="isShowingPinInput" class="d-flex flex-column">
        <label>{{ $t('security.pinInputText') }}</label>
        <b-form-input id="pin"
                      ref="pinInput"
                      v-model="model.pin"
                      name="pin"
                      type="tel"
                      pattern="[0-9]"
                      maxlength="6"
                      class="pin_mask align-self-center text-center"
                      :placeholder="$t('login.pinPlaceHolder')" />
        <b-alert v-show="showPinError" fade show variant="danger">
          <small>{{ $t('security.pinIsInvalid') }}</small>
        </b-alert>
        <div class="d-flex mt-4 justify-content-between">
          <b-link class="text-dark d-flex lead align-items-center" @click="backToUserNameInput">
            <img height="30" class="bidi-icon" src="@/assets/icons/back.svg">
            <span class="px-2">{{$t('common.back')}}</span>
          </b-link>
          <b-button variant="primary"
                    size="lg"
                    class="w-50"
                    @click="verifyPin">{{ $t('security.confirmPinButtonText') }}</b-button>
        </div>
        <ErrorBox v-if="forgotPasswordError" :errorMessage="forgotPasswordError"></ErrorBox>
      </section>
      <section v-if="isShowingResetPasswordInput">
        <b-form-group>
          <label for="resetPassword">{{$t('login.newPassword')}}</label>
          <b-form-input id="resetPassword"
                        type="password"
                        class="dir-ltr"
                        v-model.trim="model.resetPassword"
                        ref="resetPassword"
                        name="resetPassword"
                        data-vv-as="login.newPassword"
                        :state="validationState('resetPassword')"
                        v-validate="{ required: true, regex: /.{6,}$/ }"
                        aria-describedby="resetPassword"></b-form-input>
          <b-form-invalid-feedback id="resetPassword">{{ errors.first('resetPassword') }}</b-form-invalid-feedback>
        </b-form-group>

        <b-form-group>
          <label for="confirmresetPassword">{{$t('login.confirmNewPassword')}}</label>
          <b-form-input id="confirmresetPassword"
                        v-model.trim="model.confirmresetPassword"
                        type="password"
                        class="dir-ltr"
                        name="confirmresetPassword"
                        :state="validationState('confirmresetPassword')"
                        v-validate="{required:true, regex: /.{6,}$/ ,confirmed:'resetPassword'}"
                        aria-describedby="confirmresetPassword"
                        data-vv-as="login.newPassword"></b-form-input>
          <b-form-invalid-feedback id="confirmresetPassword">{{ errors.first('confirmresetPassword') }}</b-form-invalid-feedback>
        </b-form-group>
        <div class="d-flex mt-4 justify-content-between">
          <b-link class="text-dark d-flex lead align-items-center" @click="backToPinInput">
            <img height="30" class="bidi-icon" src="@/assets/icons/back.svg">
            <span class="px-2">{{$t('common.back')}}</span>
          </b-link>
          <b-button variant="primary"
                    size="lg"
                    class="w-50"
                    @click="changePassword">{{ $t('login.changePassword') }}</b-button>
        </div>
        <ErrorBox v-if="forgotPasswordError" :errorMessage="forgotPasswordError"></ErrorBox>
      </section>
      </section>
    </ValidationObserver>
  </article>
</template>

<script>
  import Vue from "vue";
    import windowSize from "@/mixins/window-size.js";
  import { mapActions, mapGetters } from "vuex";
  import SubscriptionLoading from "@/components/SubscriptionLoading.vue";
  import ErrorBox from "@/components/ErrorBox.vue";
  import PinInput from "@/components/PinInput.vue";
import {VeeValidate, ValidationObserver} from 'vee-validate';

  export default {
    name: "LoginForm",
    mixins: [windowSize],
    components: {
      SubscriptionLoading,
      ErrorBox,
      PinInput,
      ValidationObserver
    },
    computed: {
      ...mapGetters({
        resetToken: "auth/resetToken"
      })
    },
    props: {
      showPinError: Boolean
    },
    data() {
      return {
        isloading: false,
        serverError: null,
        forgotPasswordError: null,
        pageHeight: null,
        isShowingForgotPassword: false,
        isShowingUserNameInput: false,
        isShowingPinInput: false,
        isShowingResetPasswordInput: false,
        cellOrEmailAsynValidationMessage: null,
        usernameAsyncValidationMessage: null,
        isPasswordVisible: false,
        passwordFieldType: 'password',
        pin: "",
        inputType: {
          cellOrEmailLabel: "",
          cellOrEmailPlaceholder: "",
          type: "text",
          loginType: "",
          regex: /(?:(\d{10,13})|(([0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*@([0-9a-zA-Z][-\w]*[0-9a-zA-Z]\.)+[a-zA-Z]{2,9})))$/
        },
        model: {
          username: "",
          password: "",
          rememberMe: false,
          resetPassword:"",
          confirmresetPassword:""
        }
      };
    },
    methods: {
      ...mapActions({
        loginUser: "auth/authenticateOrganicUser",
        sendResetToken: "auth/sendResetToken",
        verifyToken: "auth/verifyToken",
        resetPassword: "auth/resetPassword"
      }),
      login() {
        let input = {
          username: this.model.username,
          password: this.model.password
        };

      const isValid = this.$refs.loginForm.validate();
      if (!isValid) {
        return
      }

        // this.$validator.validate().then(valid => {
        //   if (!valid) {
        //     return;
        //   }
          this.isloading = true;
          this.serverError = null;
          this.loginUser(input)
            .then(response => {
              if (response.resultType === "Success") {
                this.isloading = false;
                this.$ga.event('Registration', 'LoginSuccessful')
                let productId = localStorage.getItem('lastProductPageId')
                if(productId)
                {
                  let productRedirectUrl = '/product/'+productId
                  localStorage.removeItem('lastProductPageId')
                  window.location.href = productRedirectUrl
                }
                this.$router.push({ path: "profile" });
              }
              else if (response.resultType === "InvalidUserNameOrPassword") {
                this.isloading = false;
                this.serverError =
                  this.serverError = this.$t("validations.messages.invalidUserNameOrPassword");
                setTimeout(() => {
                  this.serverError = null;
                }, 5000)
              }
            })
            .catch(error => {
              this.isloading = false;
              this.serverError = this.$t(
                "validations.messages.server_error");
              this.isloading = false;
            });
        // });
      },

      toggleInputType() {
        this.model.username = "";
        if (this.isActiveLinkCellular()) {
          this.setInputTypeToCell();
        } else {
          this.setInputTypeToEmail();
        }
        //  this.setInputTypeToCell();
      },
      isHeightChanged() {
        if (document.innerHeight < this.pageHeight) {
          return true;

        }
        return false;
      },
      initializeForm() {
        if (this.isMaxWidth768()) {
          this.setInputTypeToCell();
        } else {
          this.setInputTypeToEmail();
        }
        //  this.setInputTypeToCell();
      },
      changeWindowSize() {
        // window.addEventListener("resize", this.initializeForm);
      },
      isActiveLinkCellular() {
        if (this.inputType.loginType.indexOf("loginByCell") > -1) {
          return true;
        }
        return false;
      },
      setInputTypeToCell() {
        this.inputType.cellOrEmailLabel = "login.cell";
        this.inputType.cellOrEmailPlaceholder = "login.cellPlaceholder";
        this.inputType.type = "tel";
        this.inputType.loginType = "login.loginByEmail";
        this.inputType.regex = /\d{10,13}$/;
        setTimeout(() => {
          this.$refs.cellOrEmail.focus()
        }, 250);
      },
      setInputTypeToEmail() {
        this.inputType.cellOrEmailPlaceholder = "login.emailPlaceholder";
        this.inputType.loginType = "login.loginByCell";
        this.model.isEmail = true;
        if (this.isDesktop()) {
          this.inputType.type = "text";
          this.inputType.cellOrEmailLabel = "login.cellOrEmail";
          this.inputType.regex = /(?:(\d{10,13})|(([0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*@([0-9a-zA-Z][-\w]*[0-9a-zA-Z]\.)+[a-zA-Z]{2,9})))$/;
        } else {
          this.inputType.cellOrEmailLabel = "login.email";
          this.inputType.type = "email";
          this.inputType.regex = /([0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*@([0-9a-zA-Z][-\w]*[0-9a-zA-Z]\.)+[a-zA-Z]{2,9})$/;
          setTimeout(() => {
            this.$refs.cellOrEmail.focus()
          }, 250);
        }
      },
      forgotPassword() {
        this.isShowingForgotPassword = true;
        this.isShowingUserNameInput = true;
        this.$ga.event('Registration', 'ForgetPassword')
      },
      requestResetPasswordToken() {
        let input = {
          username: this.model.username
        }
        this.sendResetToken(input).then(response => {
          if (response.body.result.succeeded === false) {
            this.forgotPasswordError =
              this.forgotPasswordError = this.$t("validations.messages.invalidUserName");
            setTimeout(() => {
              this.forgotPasswordError = null;
            }, 3000)
          }
          else {
            this.$ga.event('Registration', 'RequestResetPasswordToken')
            this.isShowingUserNameInput = false;
            this.isShowingPinInput = true;
          }
        })
      },
      showInputError() {
        this.showPinError = true;
        setTimeout(() => {
          this.showPinError = false;
        }, 5000);
      },
      verifyPin() {
        let input = {
          username: this.model.username,
          token: this.model.pin
        }
        this.verifyToken(input).then(response => {
          if (response.body.result.succeeded === false) {
            this.forgotPasswordError =
              this.forgotPasswordError = this.$t("validations.messages.wrongPinCode");
            setTimeout(() => {
              this.forgotPasswordError = null;
            }, 3000)
          }
          else {
            this.$ga.event('Registration', 'VerfiyResetPasswordToken')
            this.isShowingPinInput = false;
            this.isShowingResetPasswordInput = true;
          }
        })
      },
      changePassword() {
        let input = {
          username: this.model.username,
          password: this.model.confirmresetPassword
        };
        this.resetPassword(input).then(response => {
          if (response.body.result.succeeded === false) {
            this.forgotPasswordError =
              this.forgotPasswordError = this.$t("validations.messages.server_error");
            setTimeout(() => {
              this.forgotPasswordError = null;
            }, 3000)
          }
          else {
            this.$ga.event('Registration', 'ChangePassword')
            this.model.resetPassword=""
            this.model.confirmresetPassword=""
            this.model.username=""
            this.pin=""
            this.isShowingResetPasswordInput = false
            this.isShowingPinInput = false
            this.isShowingUserNameInput = false
            this.isShowingForgotPassword = false
            this.$validator.reset()
             this.$bvToast.toast(this.$t('login.successfulResetPassword'), {
                title: this.$t('login.resetPassword'),
                autoHideDelay: 3000,
                appendToast: true,
                variant: 'success',
                solid: true
              })
          }
        });
      },
      backToLoginPage() {
        this.isShowingForgotPassword = false;
        this.isShowingUserNameInput = false;
      },
      backToUserNameInput() {
        this.isShowingUserNameInput = true;
        this.isShowingPinInput = false;
      },
      backToPinInput() {
        this.isShowingPinInput = true;
        this.isShowingResetPasswordInput = false;
      },
      validationState(ref) {
        if (
          this.fields[ref] &&
          this.fields[ref].dirty &&
          (this.errors.has(ref) ||
            this.cellOrEmailAsyncValidationMessage ||
            this.usernameAsyncValidationMessage)
        ) {
          return "invalid";
        } else if (
          this.fields[ref] &&
          this.fields[ref].dirty &&
          !(
            this.errors.has(ref) ||
            this.cellOrEmailAsyncValidationMessage ||
            this.usernameAsyncValidationMessage
          )
        ) {
          return "valid";
        } else if (
          this.fields[ref] &&
          (!this.fields[ref].dirty && this.errors.has(ref))
        ) {
          return "invalid";
        }
        return null;
      },
      trackGaEvent()
      {
        this.$ga.event('Registration', 'Login2Register')
      },
      togglePassword()
      {
          this.isPasswordVisible ? this.isPasswordVisible = false : this.isPasswordVisible = true
          this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
      }
    },
    mounted() {
      this.changeWindowSize();
      this.initializeForm();
      if(!this.isMaxWidth768()){
        this.inputType.cellOrEmailLabel = "login.cell";
        this.inputType.cellOrEmailPlaceholder = "login.cellPlaceholder";
      }
      this.pageHeight = document.innerHeight;
    }
  };
</script>
